import type { UseFormReturn } from 'react-hook-form';
import { Labeled, TextInputField } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IFormMode } from '~/helpers/types';
import type { IOrganizationFormValues } from './OrganizationForm';
import { FormField } from '~/components/atoms/FormField';
import { FormSection } from '~/components/atoms/FormSection';

export type IOrganizationFormMainSectionProps = IContainerProps & {
  form: UseFormReturn<IOrganizationFormValues>;
  mode: IFormMode;
};

export const OrganizationFormMainSection: React.FC<
  IOrganizationFormMainSectionProps
> = (props) => {
  const { sx, form } = props;
  const { t } = useTranslation();

  return (
    <FormSection sx={sx}>
      <Labeled label={t('common.name')} required>
        <FormField
          name="name"
          control={form.control}
          as={TextInputField}
          forwardError
          placeholder={t('common.example-value', {
            value: t('OrganizationFormMainSection.field.name.placeholder'),
          })}
        />
      </Labeled>

      <Labeled
        label={t('OrganizationFormMainSection.field.email-address.label')}
        supportingText={t(
          'OrganizationFormMainSection.field.email-address.supporting-text',
        )}
        required
      >
        <FormField
          name="email"
          control={form.control}
          as={TextInputField}
          forwardError
          type="email"
        />
      </Labeled>
    </FormSection>
  );
};
